<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">{{ $t('serviceSubscription.pageTitle') }}</h1>
      <ts-breadcrumb
        :items="[
          { text: $t('toHomePage'), href: '/' },
          {
            text: $t('serviceSubscription.pageTitle'),
            active: true
          }
        ]"
      />
    </div>
    <ts-card>
      <ts-card-wrapper>
        <div class="d-flex justify-content-between">
          <ts-button color="info" outline @click.prevent="showForm">{{
            $t('serviceSubscription.subscription')
          }}</ts-button>
          <div class="d-flex">
            <ts-input
              v-model="search"
              :placeholder="$t('search')"
              style="width: 250px"
              class="inline-block"
            />
            <ts-button
              outline
              class="ml-2"
              v-tooltip="$t('filter')"
              @click.prevent="visible = true"
            >
              <i class="fa fa-filter"></i>
            </ts-button>
          </div>
        </div>
      </ts-card-wrapper>
      <div class="overflow-auto">
        <ts-table
          :columns="columns"
          :records="resources"
          :loading="loading"
          :rowGroup="{
            field: 'student.full_name_en'
          }"
        >
          <template v-slot="{ record }">
            <td>{{ record.student.branch.branch_name_en }}</td>
            <td>{{ record.student.card_number }}</td>
            <td>{{ record.fee_type.fee_type_name }}</td>
            <td>{{ record.fee_setup.fee_name_en }}</td>
            <td>{{ record.subs_comment }}</td>
            <td class="ts-whitespace-no-wrap">{{ record.action_date }}</td>
            <td class="text-center">
              <a-popconfirm
                placement="leftTop"
                :title="$t('are_you_sure_to_delete')"
                :ok-text="$t('yes')"
                :cancel-text="$t('no')"
                @confirm="deleteRecord(record)"
              >
                <a href="#" :disabled="record._deleting">
                  <i
                    class="fas fa-circle-notch spin ml-2"
                    v-if="record._deleting"
                  ></i>
                  <i class="fa fa-trash ml-2 text-red" v-else></i>
                </a>
              </a-popconfirm>
            </td>
          </template>
        </ts-table>
      </div>
      <div class="d-flex justify-content-end p-15">
        <ts-pagination
          v-model="pagination"
          @navigate="fetchData"
        ></ts-pagination>
      </div>
      <a-drawer
        :title="$t('filter')"
        placement="right"
        :closable="false"
        :visible="visible"
        @close="() => (visible = false)"
        :zIndex="1020"
        width="300px"
      >
        <div class="row">
          <div class="col-md-12">
            <div class="form-group">
              <a-select
                style="width: 257px"
                v-model="branch_id"
                :options="branchs"
                showSearch
                mode="multiple"
                :filterOption="
                  (input, option) =>
                    option.componentOptions.children[0].text
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                "
                :maxTagCount="1"
                :maxTagTextLength="17"
                :placeholder="$t('all')"
              >
              </a-select>
            </div>
          </div>
        </div>
      </a-drawer>
    </ts-card>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import FormComponent from './form'
import { debounce } from 'lodash'
export default {
  name: 'serviceSubscription',
  components: {
    FormComponent
  },
  data () {
    return {
      loading: false,
      visible: false,
      branchs: []
    }
  },
  created () {
    this.branch_id = [this.$store.state.authUser.default_branch_id]
    this.fetchData()
    this.getBranch()
  },
  computed: {
    ...mapState('serviceSubscription', ['resources', 'pagination']),
    search: {
      get () {
        return this.$store.state.serviceSubscription.search
      },
      set (newValue) {
        this.$store.commit('serviceSubscription/SET_SEARCH', newValue)
        this.$store.commit('serviceSubscription/RESET_CURRENT_PAGE')
      }
    },
    branch_id: {
      get () {
        return this.$store.state.serviceSubscription.branch_id
      },
      set (newValue) {
        this.$store.commit('serviceSubscription/SET_BRANCH_ID', newValue)
      }
    },
    columns () {
      return [
        { name: this.$t('serviceSubscription.branch') },
        { name: this.$t('serviceSubscription.cardNumber') },
        { name: this.$t('serviceSubscription.feeType') },
        { name: this.$t('serviceSubscription.feeName') },
        { name: this.$t('serviceSubscription.comment') },
        {
          name: this.$t('serviceSubscription.createdDate'),
          style: 'width:10%'
        },
        { name: this.$t('actions'), style: 'width:2%' }
      ]
    }
  },
  methods: {
    fetchData (attributes) {
      this.loading = true
      this.$store
        .dispatch(
          'serviceSubscription/fetch',
          Object.assign(
            {
              branch_id: this.branch_id
            },
            { ...attributes }
          )
        )
        .then(response => {
          this.loading = false
        })
        .catch(error => {
          this.loading = false
          this.$toasted.error(error.message)
        })
    },
    getBranch () {
      this.$store
        .dispatch('user/getBranch', {
          filter: {
            user_branches: true
          }
        })
        .then(response => {
          this.branchs = response.data.map(el => ({
            value: el.branch_id,
            label: el.branch_name_en
          }))
        })
    },
    showForm () {
      this.$modal.show(
        FormComponent,
        {},
        {
          height: 'auto',
          width: '50%',
          scrollable: true,
          draggable: '.form-header',
          clickToClose: false
        },
        {
          'before-close': this.fetchData
        }
      )
    },
    deleteRecord (record) {
      record._deleting = true
      this.$store
        .dispatch('serviceSubscription/destroy', {
          studentId: record.student_id,
          feeSetupId: record.fee_setup_id
        })
        .then(response => {
          this.$toasted.success(response.message)
          this.fetchData()
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          record._deleting = false
        })
    }
  },
  watch: {
    search: debounce(function (search) {
      this.fetchData({ search, branch_id: this.branch_id })
    }, 500),
    branch_id: debounce(function (value) {
      this.fetchData({ branch_id: value })
    }, 500)
  },
  beforeRouteLeave (to, from, next) {
    this.$store.commit('serviceSubscription/RESET_STATE')
    next()
  }
}
</script>
